// add other necessary regex to this file so it can be excluded by sonarQube scans

// a regex for trimming leading and trailing spaces from strings.
export const trimStringRegex = /^\/+|\/+$/g;

// a regex for trimming trailing slashes from strings
export const truncateTrailingSlash = /\/+$/;